//Datos para formulario
export const initialValuesLogin = {
  username: "",
  password: "",
};

export const initialValuesFormulario = {
  usuarioId: 0,
  nombre: "",
  apellido: "",
  genero: "",
  email: "",
  tel: "",
  telefonos: [{ tipo: "", numero: "" }],
  //tipoDoc: "",
  documento: "",
  //propiedad: "",
  provincias: "",
  departamentos: "",
  localidades: "",
  calle: "",
  puerta: "",
  piso: "",
  dpto: "",
  segmento: "",
  sucursal: "",
  ubicacion: "",
  planComercial: "",
  confirmados: [],
};

// Solicitud de servicio: prospecto en zona sin servicio. Sin sucursal, sin
// segmento y sin plan comercial. Dirección en texto libre (no hay catálogo de
// Iptel para zonas sin cobertura). DNI, email y género son opcionales.
export const initialValuesSolicitud = {
  nombre: "",
  apellido: "",
  documento: "",
  genero: "",
  email: "",
  telefonos: [{ tipo: "", numero: "" }],
  provincia: "",
  localidad: "",
  calle: "",
  altura: "",
  piso: "",
  dpto: "",
  referencia: "",
};
